<div class="common-table-style">
  <div class="header-box">
    <div class="d-flex align-items-center heading-box">
      <ng-icon name="heroUsers"></ng-icon>
      <h2>Users</h2>
    </div>
    <div class="d-flex justify-content-between align-items-center col-md-6 p-0">
      <div class="dense-4 search-and-filter">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Search Users</mat-label>
          <input matInput (keyup)="applyFilter($event.target.value)" autocomplete="off">
          <mat-icon matSuffix><ng-icon name="heroMagnifyingGlass"></ng-icon></mat-icon>
        </mat-form-field>
      </div>
      <button color="accent" mat-raised-button [disabled]="!userService.permissionsValue['_USER_MANAGEMENT_ADD_']"
        [routerLink]="['/app/user/add']">
        Add User </button>
    </div>
  </div>


  <div class="inner-box">
    <mat-table class="user-table" [dataSource]="dataSource" matSort (matSortChange)="customSortData($event)">
      <ng-container matColumnDef="User Name">
        <mat-header-cell *matHeaderCellDef mat-sort-header>User Name</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <a mat-button color="accent" disableRipple
            [disabled]="!userService.permissionsValue['_USER_MANAGEMENT_VIEW_']"
            [routerLink]="['/app/user', 'view', element.id]"
            matTooltip="View User {{element.firstName + ' ' + element.lastName| titlecase}}" [matTooltipShowDelay]="300"
            [matTooltipHideDelay]="100">{{ element.firstName + ' ' + element.lastName | titlecase
            }}</a>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="Department">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Department</mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.department | titlecase }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="Role">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Role</mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.roleName | titlecase }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="Email Address">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Email Address</mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.emailAddress }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="Last Updated">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Last Updated</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <mat-progress-spinner mode="indeterminate" color="accent" diameter="30"
            *ngIf="isLoading[element.id]; else loaded"></mat-progress-spinner>
          <ng-template #loaded>
            {{ element.updateDate }}
          </ng-template>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="Status">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Status</mat-header-cell>
        <mat-cell *matCellDef="let element">

          <mat-progress-spinner mode="indeterminate" color="accent" diameter="30"
            *ngIf="isLoading[element.id]; else loaded"></mat-progress-spinner>
          <ng-template #loaded>
            <label class="switch">
              <input class="switch-input" type="checkbox" [checked]="element.status === 1"
                (change)="toggleUserStatus(element)">
              <div class="switch-button">
                <span class="switch-button-left">Inactive</span>
                <span class="switch-button-right">Active</span>
              </div>
            </label>
          </ng-template>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="Action">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Action</mat-header-cell>
        <mat-cell *matCellDef="let element" class="action">
          <a mat-button color="accent" disableRipple
            [disabled]="!userService.permissionsValue['_USER_MANAGEMENT_EDIT_']"
            [routerLink]="['/app/user', 'edit', element.id]"
            matTooltip="Edit User {{element.firstName + ' ' + element.lastName | titlecase}}"
            [matTooltipShowDelay]="300" [matTooltipHideDelay]="100"><ng-icon name="heroPencil"></ng-icon></a>

          <a mat-button color="accent" disableRipple
            [disabled]="!userService.permissionsValue['_USER_MANAGEMENT_DELETE_']"
            (click)="openDeleteConfirmation(element.id)"
            matTooltip="Delete User {{element.firstName + ' ' + element.lastName | titlecase}}"
            [matTooltipShowDelay]="300" [matTooltipHideDelay]="100"><ng-icon name="heroTrash"></ng-icon></a>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>

    </mat-table>

    <ng-container *ngIf="dataSource.filter &&  dataSource.filteredData.length === 0">
      <div class="no-data">
        <h4>No Data Found</h4>
        <p>There are no users found with <strong>'{{dataSource.filter}}'</strong></p>
      </div>
    </ng-container>

    <ng-container *ngIf="dataLoading">
      <div class="skeleton-box">
        <ngx-skeleton-loader [theme]="{height: '200px'}"></ngx-skeleton-loader>
      </div>
    </ng-container>

    <ng-container *ngIf="dataSource.data.length === 0 && !dataSource.filter && !dataLoading">
      <div class="no-data">
        <h4>No Data Found</h4>
        <p>There are no users found!</p>
      </div>
    </ng-container>

    <mat-paginator [pageSizeOptions]="[10, 30, 50]" showFirstLastButtons></mat-paginator>
  </div>
</div>